const dialogContnet = {
    resend3times: {
        id: 'resend3times',
        title: '提示',
        content: '動態密碼重新補發已達三次，請輸入正確動態密碼或重新申請變更，謝謝!',
        confirmButton: '關閉',
        closeicon: false,
        isErrorButton: true,
    },
    otpError5Times: {
        id: 'otpError5Times',
        title: '請確認',
        content: '您的動態密碼已輸入達五次，取消變更。',
        confirmButton: '關閉',
        closeicon: false,
        isErrorButton: true,
    },
    checkBDPOTP: {
        id: 'checkBDPOTP',
        title: '提示',
        content: '<p class="mb-5">本次發送動態密碼之行動電話已有他人使用，請確認本次委託交易是否續辦？</p><p>如選擇繼續辦理，為維護您的權益，後續將有專人與您電話聯繫，造成您的不便，敬請見諒！提醒您，電訪顯示代表號 02-66366850。</p>',
        confirmButton: '繼續申請',
        cancelButton: '取消申請',
        closeicon: false,
    },
    leaveA3A4A5: {
        id: 'leaveA3A4A5',
        title: '請確認',
        content: '您已離開給付帳號約定作業，若您欲重新申請，請再以通知單上之連結路徑登入。提醒您，若您是投保外幣保單限匯款給付，敬請務必回覆約定帳號，以避免延誤給付予您的時間。',
        confirmButton: '離開',
        cancelButton: '取消',
        closeicon: false,
        isErrorButton: true,
    },
};
Object.freeze(dialogContnet);
export default dialogContnet;
